/**
 * Shared team-assignment rules for Ronda and Báciga.
 *
 * Fixed seating rule: Team 1 = players 0 and 2, Team 2 = players 1 and 3.
 * Centralized here so the engine has a single source of truth instead of
 * re-deriving this formula independently in each file.
 */

export function getTeamForPlayer(playerIndex) {
    return (playerIndex === 0 || playerIndex === 2) ? 1 : 2;
}

export function getTeamKey(playerIndex) {
    return getTeamForPlayer(playerIndex) === 1 ? 'team1' : 'team2';
}

export function arePartners(playerIndexA, playerIndexB) {
    return getTeamForPlayer(playerIndexA) === getTeamForPlayer(playerIndexB);
}
